/**
 * From https://github.com/segmentio/is-url
 * RegExps.
 * A URL must match #1 and then at least one of #2/#3.
 * Use two levels of REs to avoid REDOS.
 */

const protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
const localhostDomainRE = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/;
const nonLocalhostDomainRE = /^[^\s\.]+\.\S{2,}$/;
export function isUrl(string) {
  if (typeof string !== 'string') {
    return false;
  }
  let match = string.match(protocolAndDomainRE);
  if (!match) {
    return false;
  }
  let everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }
  return localhostDomainRE.test(everythingAfterProtocol) || nonLocalhostDomainRE.test(everythingAfterProtocol);
}